import React from 'react';

const UnsavedBanner = ({ isVisible, onSaveClick }) => {
  if (!isVisible) return null;

  return (
    <div
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        background: 'linear-gradient(135deg, #fef3c7 0%, #fde68a 100%)',
        borderTop: '2px solid #f59e0b',
        padding: '0.75rem 1rem',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '1rem',
        zIndex: 1000,
        boxShadow: '0 -2px 10px rgba(0,0,0,0.1)',
        flexWrap: 'wrap',
      }}
    >
      <span
        style={{
          color: '#92400e',
          fontSize: '0.95rem',
          display: 'flex',
          alignItems: 'center',
          gap: '0.5rem',
        }}
      >
        <span>⚠️</span>
        <span>Your plan is not saved. Sign in to save your progress.</span>
      </span>

      <button
        onClick={onSaveClick}
        style={{
          padding: '0.5rem 1rem',
          background: '#f59e0b',
          color: 'white',
          border: 'none',
          borderRadius: '6px',
          fontWeight: '600',
          cursor: 'pointer',
          fontSize: '0.9rem',
          whiteSpace: 'nowrap',
        }}
      >
        Save Now →
      </button>
    </div>
  );
};

export default UnsavedBanner;
